<div class="view">
  <div class="head">
    <app-breadcrumb [constructor_name]="constructor.name"></app-breadcrumb>
  </div>
  <div class="body">
    <div style="margin: 0px 0px -6.5px 0px">
      <img
        src="https://wikipapa.org/images/banner-sumate.jpg"
        style="object-fit: contain; background-size: cover"
        width="100%"
      />
    </div>
    <br />
    <br />
    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      style="padding: 0% 15%"
    >
      <button
        mat-raised-button
        routerLink="../observaciones"
        style="
          margin-right: 1vw;
          background: #ffc10e;
          color: white;
          font-size: 2em;
          line-height: 2em;
          height: auto;
          width: auto;
          border-radius: 1.2em;
          padding: 0em 4em;
        "
      >
        Súmate AQUÍ
      </button>
    </div>
    <br />
    <br />

    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-between stretch"
      style="
        margin: 0em 10em;
        display: flex;
        border: solid 0.2em #ffc10e;
        border-left: solid 4em #ffc10e;
      "
    >
      <div
        fxFlex="40"
        fxFlex.md="50"
        fxFlex.sm="60"
        fxFlex.xs="100"
        style="display: flex; align-items: center"
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: initial;
            padding: 0 4%;
          "
        >
          <span
            class="p1 text-truncate"
            title=" Se llevarán acabo concursos con el apoyo de las autoridades, los
          colegios la comunidad y los jovenes de las diferentes comunidades"
          >
            Se llevarán acabo concursos con el apoyo de las autoridades, los
            colegios la comunidad y los jovenes de las diferentes comunidades
          </span>
        </div>
      </div>

      <div fxFlex="60" fxFlex.md="50" fxFlex.sm="40" fxFlex.xs="100">
        <div [style.margin]="'0px 0px -6.5px 0px'">
          <img
            src="https://wikipapa.org/images/clase-sumate.jpg"
            style="object-fit: contain; background-size: cover"
            width="100%"
          />
        </div>
      </div>
    </div>
    <br />
    <br />

    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      style="
        margin: 0em 10em;
        flex-direction: row;
        box-sizing: border-box;
        display: flex;
      "
    >
      <div fxFlex="24%">
        <div>
          <div style="margin: 0px 0px -6.9px 0px">
            <img
              src="https://wikipapa.org/images/foto-sumate1.jpg"
              style="object-fit: contain; background-size: cover"
              width="100%"
            />
          </div>
        </div>
        <div
          style="
            background-color: #ffc10e;
            color: #fff;
            justify-content: center;
            font-size: 1.4em;
            align-items: center;
            display: flex;
          "
        >
          <span class="p2 text-truncate-line">Capacitación</span>
        </div>
      </div>
      <div fxFlex="24%">
        <div>
          <div style="margin: 0px 0px -6.5px 0px">
            <img
              src="https://wikipapa.org/images/foto-sumate2.jpg"
              style="object-fit: contain; background-size: cover"
              width="100%"
            />
          </div>
        </div>
        <div
          style="
            background-color: #ffc10e;
            color: #fff;
            justify-content: center;
            font-size: 1.4em;
            align-items: center;
            display: flex;
          "
        >
          <span class="p2 text-truncate-line">Colegios</span>
        </div>
      </div>
      <div fxFlex="24%">
        <div>
          <div style="margin: 0px 0px -6.5px 0px">
            <img
              src="https://wikipapa.org/images/foto-sumate3.jpg"
              style="object-fit: contain; background-size: cover"
              width="100%"
            />
          </div>
        </div>
        <div
          style="
            background-color: #ffc10e;
            color: #fff;
            justify-content: center;
            font-size: 1.4em;
            align-items: center;
            display: flex;
          "
        >
          <span class="p2 text-truncate-line">Estudiantes</span>
        </div>
      </div>

      <div fxFlex="24%">
        <div>
          <div style="margin: 0px 0px -6.5px 0px">
            <img
              src="https://wikipapa.org/images/foto-sumate4.jpg"
              style="object-fit: contain; background-size: cover"
              width="100%"
            />
          </div>
        </div>
        <div
          style="
            background-color: #ffc10e;
            color: #fff;
            justify-content: center;
            font-size: 1.4em;
            align-items: center;
            display: flex;
          "
        >
          <span class="p2 text-truncate-line">Monitoreo con aplicativo</span>
        </div>
      </div>
    </div>
    <br />
    <br />
    <!-- ini -->
    <div fxLayout="row wrap" style="margin: 0em 10em">
      <div
        fxFlex="55"
        fxFlex.md="55"
        fxFlex.sm="100"
        fxFlex.xs="100"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        style="padding: 2%; background-color: #ffeba2"
      >
        <div fxFlex="20" fxFlex.md="20" style="padding: 0% 2%">
          <img
            src="https://wikipapa.org/images/icono-sumate.png"
            style="object-fit: contain; background-size: cover"
            width="100%"
          />
        </div>
        <div fxFlex="80" fxFlex.md="80" style="padding: 0% 2%">
          <span class="p3">
            Lo invitamos a unirse a esta iniciativa. Súmate a la conservación de
            nuestro patrimonio
          </span>
        </div>
      </div>

      <div fxFlex="45" fxFlex.md="45" fxFlex.sm="100" fxFlex.xs="100">
        <div [style.margin]="'0px 0px -6.5px 0px'">
          <img
            src="https://wikipapa.org/images/papitas-sumate.jpg"
            style="object-fit: contain; background-size: cover"
            width="100%"
          />
        </div>
      </div>
    </div>
    <!-- fin -->
    <br />
    <br />
  </div>
</div>
